import React from "react";
import Page from "components/Page";
import { Props } from "./ProjectStatusCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const ProjectStatusCustomTypes = lazyWithRetry(() =>
  import("./ProjectStatusCustomTypes")
);

export default (props: Props) => (
  <Page>
    <ProjectStatusCustomTypes {...props} />
  </Page>
);
